import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const CACHE_KEY = "site_settings_cache_v1";

function loadCached() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

const SettingsContext = createContext({ settings: {}, reload: () => {} });

export function SettingsProvider({ children }) {
  // Hydrate from cache synchronously so the app name appears instantly on refresh
  const [settings, setSettings] = useState(() => loadCached() || {});

  const reload = useCallback(() => {
    api.get("/settings").then((r) => {
      const data = r.data || {};
      setSettings(data);
      try { localStorage.setItem(CACHE_KEY, JSON.stringify(data)); } catch { /* quota */ }
    }).catch(() => {});
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return (
    <SettingsContext.Provider value={{ settings, reload }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSiteSettings() {
  return useContext(SettingsContext);
}
